export default __webpack_public_path__ + "17eef6434cd7d8d0322549b4c06fa1bc.png";